import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { CONFIG } from 'src/app/dataModels/config';
import { CONSTANTS } from 'src/app/dataModels/constants';
import { HelperService } from '../utils/helper.service';
import { UserService } from '../user/user.service';

/**
 * Component Access service
 */
@Injectable({
  providedIn: 'root'
})
export class CompAccessService {
  /**
   * Constructor to inject dependency
   * @param apiService instance of ApiService
   * @param helperService instance of helperService
   * @param userService instance of userService
   */
  constructor(private apiService: ApiService, private helperService: HelperService, private userService: UserService) {}

  /**
   * Check if user has access to the component list provided
   * @param compNameList list of components
   */
  async checkAccess(compNameList: Array<any>) {
    const compAccess = {} as any;

    let deniedCount = 0;

    const compAccessList = this.userService?.getCompAccessList();

    for (const comp of compNameList) {
      const matchedCompAccessList = compAccessList?.filter(userComp => userComp === comp.toUpperCase());

      if (matchedCompAccessList?.length > 0) {
        // tslint:disable-next-line: no-unused-expression
        compAccess[comp.toUpperCase()] = CONSTANTS.ALLOWED;
      } else {
        // tslint:disable-next-line: no-unused-expression
        compAccess[comp.toUpperCase()] = CONSTANTS.DENIED;
        deniedCount++;
      }
    }

    if (deniedCount === compNameList?.length) {
      compAccess.allDenied = 'Y';
    } else {
      compAccess.allDenied = 'N';
    }

    return compAccess;
  }
}
